import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { capitalize, get, replace } from 'lodash';
import { HttpClient } from '@angular/common/http';
import { FileService } from 'app/services/file.service';

@Component({
  selector: 'crud-field-image',
  template: `
    <div *ngIf="!rawImg" class="flex flex-col mb-4">
      <div class="font-bold capitalize" *ngIf="label">{{ label }}</div>
      <div [class]="noMargin ? '' : 'ml-2 mt-1'">
        <img
          [src]="value | secure | async"
          *ngIf="value"
          [ngClass]="getImageClasses()"
          [alt]="alt"
        />
        <div [class]="noMargin ? '' : 'ml-2'" *ngIf="!value">
          {{ value ?? '-' }}
        </div>
      </div>
    </div>

    <!-- Raw image mode - just the image element -->
    <img
      *ngIf="rawImg && value"
      [src]="value | secure | async"
      [ngClass]="getImageClasses()"
      [alt]="alt"
    />

    <!-- Handle no value case for raw mode -->
    <div *ngIf="rawImg && !value" [ngClass]="getImageClasses()">
      {{ value ?? '-' }}
    </div>
  `,
})
export class CrudFieldImageComponent implements OnChanges, OnInit {
  @Input() resource: any;
  @Input() label: string = '';
  @Input() uuid?: string = '';
  @Input() name: string = '';
  @Input() value: string = null;
  @Input() alt: string = null;
  @Input() rounded: boolean = false;
  @Input() noMargin: boolean = false;
  @Input() rawImg: boolean = false;
  @Input() roundedClass: string =
    'm-auto rounded-full h-20 w-20 overflow-hidden';

  imageUrl: string;
  public signatureValue: string;

  constructor(
    private http: HttpClient,
    private fileService: FileService
  ) {}

  public ngOnInit(): void {
    if (this.label == '') {
      this.label = capitalize(replace(this.name, /_/g, ' '));
    }
    if (this.uuid) {
      this.loadFilePreview();
    }

    if (!this.value) {
      this.signatureValue = get(this.resource, this.name);
    } else {
      this.signatureValue = this.value;
    }
  }

  private async loadFilePreview(): Promise<void> {
    this.value = await this.fileService.fetchFileOrFallback(this.uuid);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['uuid']?.currentValue) {
      this.loadFilePreview();
    }

    if (changes['value']) {
      if (!this.value) {
        this.signatureValue = get(this.resource, this.name);
      } else {
        this.signatureValue = this.value;
      }
    }
  }

  getImageClasses(): string {
    return this.rounded ? this.roundedClass : 'max-w-52 border border-gray-400';
  }
}
